import {atom, createStore} from "jotai";

/**
 *
 * @type global modal Controller
 */
export const modalController = atom({
  isShow: false,
  modalComponent: null,
  reRender: false
})

export const roleAtom = atom('')

export const authStatusAtom = atom('idle')

export const tokenResultAtom = atom({
  accessToken: '',
  refreshToken: '',
  id: '',
  role: '',
  name: '',
  username: '',
  serverName: '',
})

export const adminInfoAtom = atom({
  email: '',
  name: '',
  convertedUser: '',
  id: '',
  accountProfile: '',
})

export const userInfoAtom = atom({
  email: '',
  name: '',
  id: '',
})

const store = createStore()

export default store;
